<template>
    <ul class="list-items pa-0">
        <li
            v-for="(item, index) in items"
            :key="item.id"
            :id="item.id"
            class="list-item"
            :class="{ hover: isItemHovered(item.id) }"
            @click.prevent="$emit('item-clicked', item.id, index, item.name)"
            @mouseover="$emit('item-mouseover', item.id)"
            @mouseout="$emit('item-mouseout', item.id)"
        >
            <button type="button" class="w-100 text-left">
                <p :class="item.description ? 'mb-2' : 'm-0'">{{ item.name }}</p>
                <span class="property-description">{{ item.description }}</span>
            </button>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        /**
         * @param items This array must contain objects with at least the properties id, name
         */
        items: {
            type: Array,
            required: true,
            validator: function(items) {
                let optionKeys;
                const itemsLength = items.length;
                for (let i = 0; i < itemsLength; i++) {
                    let option = items[i];
                    optionKeys = Object.keys(option);

                    const requiredObjectProps = ['id', 'name'];

                    if (optionKeys.length < requiredObjectProps.length) {
                        console.error('items must contain the props [' + requiredObjectProps + ']');
                        return false;
                    }

                    const requiredObjectPropsLength = requiredObjectProps.length;
                    for (let j = 0; j < requiredObjectPropsLength; j++) {
                        const requiredProp = requiredObjectProps[j];

                        if (!optionKeys.includes(requiredProp)) {
                            console.error('items must contain the prop => ' + requiredProp);
                            return false;
                        }
                    }
                }

                return true;
            }
        },
        hoverItem: {
            type: [Number, String]
        }
    },
    watch: {
        hoverItem(newVal) {
            if (newVal) {
                const hoveredRowHtmlElement = this.$el.querySelector(`[id*="${newVal}"]`);
                hoveredRowHtmlElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    },
    methods: {
        isItemHovered(itemId) {
            return +itemId.toString().split('-')[0] === +this.hoverItem;
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';
.list-item {
    display: flex;
    align-items: center;
    padding: 13px 20px;
    border-radius: 7px;
    margin-top: 10px;
    font-size: 15px;
    line-height: 17px;
    color: #4b4849;
    cursor: pointer;
    outline: none;
    background-color: $grey-medium;

    &:hover {
        color: $white;
        background-color: var(--v-primary-base);
    }

    &.hover {
        color: $white;
        background-color: var(--v-primary-base);
    }
    &:hover{
        .property-description {
            color: $white;
        }
    }
    .property-description {
        color: $grey;
        font-size: 0.8rem;

    }
}
</style>
